module.exports = __webpack_public_path__ + "img/silver.ae04af8d.png";